import { render, staticRenderFns } from "./vueLottie.vue?vue&type=template&id=61fd5846&scoped=true&"
import script from "./vueLottie.vue?vue&type=script&lang=js&"
export * from "./vueLottie.vue?vue&type=script&lang=js&"
import style0 from "./vueLottie.vue?vue&type=style&index=0&id=61fd5846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd5846",
  null
  
)

export default component.exports